import { render } from "./LayoutLegacy.vue?vue&type=template&id=7099fac4"
import script from "./LayoutLegacy.vue?vue&type=script&lang=js"
export * from "./LayoutLegacy.vue?vue&type=script&lang=js"

import "./LayoutLegacy.vue?vue&type=style&index=0&id=7099fac4&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__